/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { fetchData, toasterrormsg } from '../../../reusable'
import { Tr } from '../../../_metronic/i18n/Tr';

interface AddSpaceHeaderProps {
  spacerentalId: string; // Assuming spacerentalId is of type string, adjust as needed
}
const AddSpaceHeader: React.FC<AddSpaceHeaderProps> = ({ spacerentalId }) => {
  const t = Tr()
  const location = useLocation();
  const editSpacerentalId = (location.state as any)?.spacerentalId || '';
  const [spaceRenatalDetails, setSpacerentalDetails] = useState([]);

  // space Details api call
  const spaceDetailsApiCall = async () => {

    var param: any = {
      spacerentalId: String(editSpacerentalId),
    }
    var response: any = await fetchData("public/spaceDetails", param)

    if (response.status == "200") {
      setSpacerentalDetails(response.data);
    }
    else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {

    if (editSpacerentalId != "") {
      spaceDetailsApiCall()
    }
  }, [])

  const tabRefs = useRef([]) as any;
  const indexTab = sessionStorage.getItem('indexTab') || 0;

  useEffect(() => {
    const scrollToTab = () => {
      // Check if the tabRefs array is populated and if the indexTab element exists
      if (tabRefs.current.length > 0 && tabRefs.current[indexTab]) {
        // Delay scrollIntoView to ensure all rendering is complete
        setTimeout(() => {
          tabRefs?.current[indexTab]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',  // Scroll vertically to nearest edge
            inline: 'center'   // Scroll horizontally to center
          });
        }, 700);
      }
    };
    scrollToTab();
    // Add event listener for window load event to handle case of page refresh
    window.addEventListener('load', scrollToTab);
    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('load', scrollToTab);
    };
  }, [location, indexTab]);
  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-body'>
          <div className='d-flex overflow-auto'>
            <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder my-2 flex-nowrap'>
              <li className='nav-item'>
                {
                  spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['basicInfo'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['basicInfo'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspacebasicinfo/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['basicInfo'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addspacebasicinfo/'
                      state={{ spacerentalId: editSpacerentalId }}
                      ref={el => (tabRefs.current[0] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '0')}
                    >
                      {t('Basic Info')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['basicInfo'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspacebasicinfo/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['basicInfo'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[0] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '0')}
                    >
                      {t('Basic Info')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['location'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['location'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspacelocation/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['location'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addspacelocation/'
                      state={{ spacerentalId: editSpacerentalId }}
                      ref={el => (tabRefs.current[1] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '1')}
                    >
                      {t('Location')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['location'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspacelocation/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['location'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[1] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '1')}
                    >
                      {t('Location')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['propertyDetail'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['propertyDetail'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspacedetails/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['propertyDetail'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addspacedetails/'
                      state={{ spacerentalId: editSpacerentalId }}
                      ref={el => (tabRefs.current[2] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '2')}
                    >
                      {t('Property Details')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['propertyDetail'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspacedetails/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['propertyDetail'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[2] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '2')}
                    >
                      {t('Property Details')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['rentableSpace'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['rentableSpace'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewrentablespaces/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['rentableSpace'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../viewrentablespaces/'
                      state={{ spacerentalId: editSpacerentalId }}
                      ref={el => (tabRefs.current[3] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '3')}
                    >
                      {t('Space Options')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['rentableSpace'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewrentablespaces/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['rentableSpace'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[3] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '3')}
                    >
                      {t('Space Options')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['photos'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['photos'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspacephotos/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['photos'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addspacephotos/'
                      state={{ spacerentalId: editSpacerentalId }}
                      ref={el => (tabRefs.current[4] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '4')}
                    >
                      {t('Photos')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['photos'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspacephotos/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['photos'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[4] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '4')}
                    >
                      {t('Photos')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['facilitiesAndServices'] ? (
                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['facilitiesAndServices'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspacefacilities/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['facilitiesAndServices'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addspacefacilities/'
                      state={{ spacerentalId: editSpacerentalId }}
                      ref={el => (tabRefs.current[5] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '5')}
                    >
                      {t('Facilities & Services')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['facilitiesAndServices'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspacefacilities/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['facilitiesAndServices'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[5] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '5')}
                    >
                      {t('Facilities & Services')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['availability'] ? (

                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['availability'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspaceavailability/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['availability'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addspaceavailability/'
                      state={{ spacerentalId: editSpacerentalId }}
                      ref={el => (tabRefs.current[6] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '6')}
                    >
                      {t('Availability')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['availability'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspaceavailability/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['availability'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[6] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '6')}
                    >
                      {t('Availability')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['policies'] ? (

                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['policies'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspacepolicies/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['policies'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addspacepolicies/'
                      state={{ spacerentalId: editSpacerentalId }}
                      ref={el => (tabRefs.current[7] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '7')}
                    >
                      {t('Policies')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['policies'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspacepolicies/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['policies'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[7] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '7')}
                    >
                      {t('Policies')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['financeAndLegal'] ? (

                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['financeAndLegal'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspacefinance/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['financeAndLegal'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../addspacefinance/'
                      state={{ spacerentalId: editSpacerentalId }}
                      ref={el => (tabRefs.current[8] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '8')}
                    >
                      {t('Finance & Legal')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['financeAndLegal'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/addspacefinance/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['financeAndLegal'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[8] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '8')}
                    >
                      {t('Finance & Legal')}
                    </button>
                  )
                }
              </li>
              <li className='nav-item'>
                {
                  spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['contract'] ? (

                    <Link
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['contract'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewspacecontract/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['contract'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      to='../viewspacecontract/'
                      state={{ spacerentalId: editSpacerentalId }}
                      ref={el => (tabRefs.current[9] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '9')}
                    >
                      {t('Contract Agreement')}
                    </Link>
                  ) : (
                    <button
                      className={`nav-link text-active-primary me-6 p-3 text-nowrap ${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['contract'] ? "bg-primary text-white rounded" : 'bg-transparent'
                        } ${location.pathname === '/viewspacecontract/' ? `${spaceRenatalDetails && spaceRenatalDetails.length > 0 && spaceRenatalDetails[0]['completedSteps'] && spaceRenatalDetails[0]['completedSteps']['contract'] ? 'active_tab bg-success text-white' : 'active'}` : ''
                        }`}
                      ref={el => (tabRefs.current[9] = el)}
                      onClick={() => sessionStorage.setItem('indexTab', '9')}
                    >
                      {t('Contract Agreement')}
                    </button>
                  )
                }
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

export { AddSpaceHeader }
